import { render, staticRenderFns } from "./AddIntegrationModal.vue?vue&type=template&id=10c21d10&"
import script from "./AddIntegrationModal.vue?vue&type=script&lang=js&"
export * from "./AddIntegrationModal.vue?vue&type=script&lang=js&"
import style0 from "./AddIntegrationModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports